import styled, { StyledComponent } from 'styled-components'
import { Views } from '../../../enums'

const Row = styled.div<RowProps>`
  padding-top: 14px;
  padding-bottom: 14px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: ${({ view }) => view === Views.default ? `
    space-evenly
  ` : `
    space-between
  `};
  align-items: center;
  ${({ view }) => view === Views.default && `
    @media(max-width: 767px) {
      padding-top: 7px;
      padding-bottom: 7px;
    }
  `}
`

export default Row

export interface RowProps {
  view: Views
}
